import { isBackgroundRoutePrefetchImport } from "../app/idleRoutePrefetchReloadGuard";

const LAST_RELOAD_KEY = "vitePreloadErrorReloadedAt";
const MIN_RELOAD_INTERVAL_MS = 10_000;

const readLastReload = (): number => {
  try {
    return Number(window.sessionStorage.getItem(LAST_RELOAD_KEY)) || 0;
  } catch {
    return 0;
  }
};

const writeLastReload = (now: number) => {
  try {
    window.sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
  } catch {
    // Storage blocked: still reload, the interval guard just won't hold.
  }
};

export const handlePreloadError = (
  event: Event,
  now: number = Date.now(),
  reload: () => void = () => window.location.reload()
) => {
  if (isBackgroundRoutePrefetchImport()) return;

  // A rapid repeat means the reload didn't help, so let the error surface.
  if (now - readLastReload() < MIN_RELOAD_INTERVAL_MS) return;

  // A deploy replaced the chunk this tab was built against (HELP-11164).
  event.preventDefault();
  writeLastReload(now);
  reload();
};

export const reloadOnPreloadError = () => {
  window.addEventListener(
    "vite:preloadError",
    (event) => handlePreloadError(event),
    { capture: true }
  );
};
